import React, { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { notification } from "antd";

// assets
import { LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
//import CustomIcons from 'components/CustomIcons';

function NotificationHandleUpdate({
  Loading,
  Successful,
  isNew,
  // default props
  message,
  messageSuccess,
  description,
  descriptionError,
}) {
  const { t } = useTranslation();

  const defaultMessage = `${t("common.update")}!`;
  const defaultMessageSuccess = `${t("common.updated")}!`;
  const defaultDescription = t("notifications.dataSaved");
  const defaultDescriptionError = t("errors.notifSimpleError");

  // Loading Notifications
  useEffect(() => {
    if ((Loading && !Successful && !isNew) || (!isNew && Successful)) {
      updateNotification(Loading, isNew, Successful);
    }
  }, [Loading, isNew, Successful]);

  const updateNotification = useCallback(
    (Loading, isNew, Successful) => {
      return notification.info({
        duration: 2,
        icon: (
          <>
            {Loading && !Successful && (
              <LoadingOutlined style={{ color: "#F59C05" }} />
            )}
            {Successful && <CheckCircleOutlined style={{ color: "#28A745" }} />}
          </>
        ),
        message: Successful ? (
          !!messageSuccess && messageSuccess || defaultMessageSuccess
        ) : (
          !!message && message || defaultMessage
        ),
        description: Successful ? (
          !!description && description || defaultDescription
        ) : (
          !!descriptionError && descriptionError || defaultDescriptionError
        ),
      });
    },
    [
      description,
      descriptionError,
      messageSuccess,
      message,
      Loading,
      isNew,
      Successful,
    ],
  );

  return <></>;
}

NotificationHandleUpdate.defaultProps = {};

export default NotificationHandleUpdate;
